import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

/**
 * Fetch the physiotherapy financial metrics.
 * @param {{ date_from?: string, date_to?: string }} [params] optional inclusive range
 *   (yyyy-MM-dd, local calendar day). Either bound may be omitted (open-ended); omit both
 *   for all-time figures.
 */
export const fetchEarningsMetricsReducer = createAsyncThunk(
  "earnings/fetchMetrics",
  async (params = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const query = new URLSearchParams();
      if (params?.date_from) query.append("date_from", params.date_from);
      if (params?.date_to) query.append("date_to", params.date_to);
      const qs = query.toString();
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.physioEarningsMetrics}${qs ? `?${qs}` : ""}`;
      const response = await axiosPrivate.get(fullUrl);

      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      } else {
        const msg = response?.data?.message || "Failed to fetch earnings metrics.";
        toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      console.error("Error fetching earnings metrics:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while fetching earnings metrics.";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);
